import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('../pages/index'),
      meta:{
        title:"iTrust联合信任 - 第三方数据安全信用数据互信平台"
      }
    },
    {
      path: '/list',
      name: 'list',
      component: () => import('../pages/list'),
      meta:{
          title:"数据检索 - iTrust联合信任"
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js